export interface ClonedVoice {
  id: string;
  local_voice_name: string;
  provider: string;
  provider_voice: string;
  language: string;
  gender: string;
  active: boolean;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface OrganizationVoice {
  local_voice_name: string;
  gender: string;
  active: boolean;
}

/** `allowed_voices: null` means TechLadder has not restricted this organization. */
export interface OrganizationVoiceInventory {
  allowed_voices: string[] | null;
  voices: OrganizationVoice[];
}

export const CLONE_LANGUAGES = [
  { value: "hi", label: "Hindi" },
  { value: "en", label: "English" },
] as const;

export const CLONE_GENDERS = [
  { value: "Female", label: "Female" },
  { value: "Male", label: "Male" },
] as const;

/** The clip Cartesia is given. Longer samples do not improve an instant clone. */
export const CLIP_SECONDS = 10;
